import { EquipmentComponent } from './../equipment.component';
import { Component, OnInit } from '@angular/core';
import { TextModel } from '../../../models/text';
import { BaseComponent } from '../../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { TextService } from '../../../services/text.service';
import { AuthService } from 'src/services/guard/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-equipment-mobile',
  templateUrl: './equipment-mobile.component.html',
  styleUrls: ['./equipment-mobile.component.scss']
})
export class EquipmentMobileComponent extends EquipmentComponent implements OnInit {
  constructor(
    translate: TranslateService,
    textService: TextService,
    authService: AuthService,
    deviceDetectorService: DeviceDetectorService,
    route: ActivatedRoute
  ) {
    super(translate, textService, authService, deviceDetectorService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
